import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import ArrowDownIcon from '../assets/icons/ArrowDownIcon';

const MinimalToggle = React.forwardRef(({ children, onClick, value }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: '#1F2937',
      padding: 0,
      border: 'none',
      background: 'transparent',
    }}
  >
    <span>{value || children}</span>
    <ArrowDownIcon />
  </div>
));

MinimalToggle.displayName = 'MinimalToggle';

export const FormDropdown = ({ value, items = [], onChange, maxHeight = '200px' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      show={isOpen}
      onToggle={(isOpen) => setIsOpen(isOpen)}
      onSelect={(eventKey) => {
        onChange(eventKey);
        setIsOpen(false);
      }}
    >
      <Dropdown.Toggle as={MinimalToggle} value={value} />
      <Dropdown.Menu
        style={{
          maxHeight: maxHeight,
          overflowY: 'auto',
          width: '100%',
        }}
      >
        {items.map((item, index) => (
          <Dropdown.Item key={index} eventKey={item.value || item}>
            {item.label || item}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

FormDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ])
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  maxHeight: PropTypes.string,
};
